import { isUndefined } from "lodash";
export default function getListBrandsInCountries(data) {
  let brandsInCountries = [];
  for (let item of data) {
      let brandInCountry = {
          name: item.name,
          id: item.id,
          brand: !isUndefined(item.field_brand[0]) ? item.field_brand[0].target_id : '',
          country: !isUndefined(item.field_country[0]) ? item.field_country[0].target_id : '',
          field_our_brands_franchise_url: !isUndefined(item.field_our_brands_franchise_url[0]) ? item.field_our_brands_franchise_url[0].uri : '',
          field_our_brands_brand_url: !isUndefined(item.field_our_brands_brand_url[0]) ? item.field_our_brands_brand_url[0].uri : '',
          field_our_brands_career_url: !isUndefined(item.field_our_brands_career_url[0]) ? item.field_our_brands_career_url[0].uri : '',
          contactText: !isUndefined(item.field_franchise_contact_rich[0]) ? item.field_franchise_contact_rich[0].value : '',
      };
      brandsInCountries.push(brandInCountry);
  }
  return brandsInCountries;
}